var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconlinux(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_542_3781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H34V34H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_542_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0014 7.44312V6.96242C14.0014 6.31345 14.5275 5.78731 15.1765 5.78731C15.8254 5.78731 16.3516 6.31345 16.3516 6.96242V6.88676",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 6.88676V6.96242C18.6484 6.31338 19.1745 5.78725 19.8235 5.78725C20.4725 5.78725 20.9986 6.31338 20.9986 6.96242V7.44312",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0753 8.64854L14.6951 9.21515C14.0997 9.45962 13.9506 10.2345 14.4128 10.6825L16.8786 13.0718C17.2249 13.4074 17.775 13.4074 18.1213 13.0718L20.5871 10.6825C21.0493 10.2345 20.9002 9.45962 20.3048 9.21515L18.9247 8.64854C18.0118 8.27381 16.9881 8.27381 16.0753 8.64854Z",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3577 22.327C9.89589 23.7731 9.63827 25.3833 9.63827 27.0805C9.63827 27.4637 9.65206 27.8423 9.67784 28.2158",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3222 28.2158C25.3479 27.8424 25.3617 27.4637 25.3617 27.0805C25.3617 20.8072 21.8419 15.7217 17.5 15.7217C15.3107 15.7217 13.3305 17.0146 11.905 19.1008",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01242 28.4846C7.79813 26.7809 7.08489 24.6932 7.08495 22.4338C7.08491 21.7768 7.14671 21.1213 7.26955 20.476L4.13932 22.7783C3.57271 23.1951 2.7965 22.6664 2.97878 21.987C3.66443 19.4317 5.34375 14.9819 9.10356 12.427C10.6441 11.3801 11.572 9.63453 11.5055 7.77319L11.5036 7.72394C11.3677 4.26043 14.1778 1.40335 17.6456 1.48546C19.6386 1.53267 21.3932 2.56618 22.4499 4.10664",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9807 28.4805C27.1985 26.7757 27.9151 24.6882 27.9151 22.4335C27.9151 21.764 27.8508 21.1097 27.7301 20.4754L30.8607 22.778C31.4275 23.1948 32.2036 22.6659 32.0212 21.9864C31.3344 19.4268 29.6503 14.9661 25.876 12.4129C24.3898 11.4075 23.4872 9.74659 23.4916 7.96033",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5774 32.0894C14.7753 32.5741 16.0852 32.8436 17.4598 32.8488C18.8616 32.8541 20.1989 32.5818 21.4209 32.0848",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6296 31.7915C13.6296 32.7442 12.0865 33.5166 10.183 33.5166C8.27953 33.5166 6.73646 32.7442 6.73646 31.7915C6.73646 30.8388 8.27953 28.1529 10.183 28.1529C12.0865 28.1529 13.6296 30.8388 13.6296 31.7915Z",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2635 31.7915C28.2635 32.7442 26.7205 33.5166 24.8169 33.5166C22.9135 33.5166 21.3704 32.7442 21.3704 31.7915C21.3704 30.8388 22.9135 28.1529 24.8169 28.1529C26.7205 28.1529 28.2635 30.8388 28.2635 31.7915Z",
    stroke: "#545454",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlinux);
export default __webpack_public_path__ + "static/media/Icon=linux.9f8abfe75a3dc62ea1024d0d25f3ea4f.svg";
export { ForwardRef as ReactComponent };